import { FC } from "react";
import { useResourceRegister } from "~/utils/resourceRegister";

const GovernanceResourceRegister: FC = () => {
  useResourceRegister({ name: 'governance/dashboard' })
  useResourceRegister({ name: 'databases-dictionary' })
  useResourceRegister({ name: 'governance' })
  useResourceRegister({ name: 'govrnc-catalog-classi-statics' })
  useResourceRegister({ name: 'govrnc-catalog-encrypt-statics' })
  useResourceRegister({ name: 'govrnc-retention-rule' })
  useResourceRegister({ name: 'govrnc-reason-collect' })
  useResourceRegister({ name: 'govrnc-dashboard' })
  return (
    null
  )
}

export default GovernanceResourceRegister;
